import { WHITE_SPACE, WHITE_SPACE_PATTERN } from '../constants'
import { measureText } from '../utils'

import TextRule from './TextRule'

const SPACE = ' '

export default class WhiteSpace extends TextRule {
  getType() {
    return WHITE_SPACE
  }

  getWidth() {
    if (this.width !== null) {
      return this.width
    }
    this.width = measureText(SPACE, this.font).width
    return this.width
  }

  draw(ctx) {
    this.drawDecoration(ctx)
  }
}

WhiteSpace.pattern = WHITE_SPACE_PATTERN
